import React, { FC, useCallback } from 'react';
import { useField, useFormikContext } from 'formik';

import Control from 'components/MarkupInputsControl/MarkupInputsControl';

import { MarkupType } from '__generated__/PackageEditMain_package.graphql';

const MarkupInputs: FC = () => {
  const [typeField] = useField<MarkupType>('markupType');
  const [valueAdultField] = useField('markupValueAdult');
  const [valueChildField] = useField('markupValueChild');
  const { setFieldValue } = useFormikContext<any>();

  const handleTypeChange = useCallback(
    (type: string) => {
      setFieldValue('markupType', type);
    },
    [setFieldValue]
  );

  const handleValueChange = useCallback(
    (value: string, isAdult: boolean) => {
      const name = isAdult ? 'markupValueAdult' : 'markupValueChild';
      setFieldValue(name, Number(value));
    },
    [setFieldValue]
  );

  return (
    <Control
      type={typeField.value}
      valueAdult={valueAdultField.value}
      valueChild={valueChildField.value}
      onTypeChange={handleTypeChange}
      onValueChange={handleValueChange}
    />
  );
};

export default MarkupInputs;
